import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { configureMoment } from '@gyselroth/angular-moment';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { GraphQLModule } from './graphql.module';
import {
  HTTP_INTERCEPTORS,
  HttpClientModule,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { GriconsAngularModule } from '@gyselroth/gricons-angular';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { IonicModule } from '@gyselroth/ionic-angular';
import moment from 'moment-timezone';
import {
  AbstractAuthConfigService,
  AuthModule,
  provideAngularAuth,
} from '@gyselroth/angular-auth';
import { AuthConfigService } from './shared/auth-config/services/auth-config.service';
import { MsalModule, MsalRedirectComponent } from '@azure/msal-angular';
import {
  BrowserCacheLocation,
  PublicClientApplication,
} from '@azure/msal-browser';
import { MsalSkipInterceptor } from './shared/msal/services/msalskip-interceptor.service';
import {
  MSALGuardConfigFactory,
  MSALInterceptorConfigFactory,
} from './msal-init-configs';
import { authServiceAppInitProvider } from './auth/auth-app-initializer';

const timeZone = 'Europe/Zurich';
configureMoment(timeZone);

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent, MsalRedirectComponent],
  imports: [
    HttpClientModule,
    RouterModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    GriconsAngularModule.forRoot(),
    GraphQLModule,
    CommonModule,
    IonicModule.forRoot({
      moment,
      timeZone,
      mode: 'ios',
    }),
    AuthModule,
    MsalModule.forRoot(
      new PublicClientApplication({
        auth: {
          clientId: 'd0349e9f-7609-43f3-beee-6cf2ac3ccccb',
          authority: 'https://login.microsoftonline.com/organizations',
          redirectUri: `${location.origin}/msal-callback`,
        },
        cache: {
          cacheLocation: BrowserCacheLocation.SessionStorage,
        },
      }),
      MSALGuardConfigFactory(),
      MSALInterceptorConfigFactory()
    ),
  ],
  providers: [
    { provide: AbstractAuthConfigService, useExisting: AuthConfigService },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalSkipInterceptor,
      multi: true,
    },
    provideHttpClient(withInterceptorsFromDi()),
    provideAngularAuth(true),
    authServiceAppInitProvider,
  ],
})
export class AppModule {}
